/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import Home from './home'
import Primary from './primary'

type Props = {
    type: 'home' | 'primary'
    title?: string
    description?: string
}

const Hero = ({ type, title, description }: Props) => {
    return (
        <>
            {type === 'home' ?
                <Home />
            :
                <Primary title={title} description={description} />
            }
            <svg width="100%" height="90" viewBox="0 0 500 80" className="absolute" preserveAspectRatio="none">
                <defs>
                    <clipPath id="shape">
                        <path d="M0,0 L0,40 Q250,80 500,40 L500,0 Z" />
                    </clipPath>
                </defs>
                <rect x="0" y="0" width="500" height="90" fill="#33446f" clipPath="url(#shape)" />
            </svg>
        </>
    )
}

export default Hero